(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderCruiseDayImage',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		Adzuki.Typeahead(
			'#fitbuildercruisedayimage-search',
			'/Searches/googleAutocomplete/',
			function select(item) {
				console.log(item.id);
				Adzuki.Ajax.get('/Searches/googlePlace/' + item.id)
				.then(function _getPlaceDetails(html) {
					$('.pictures').html(html);
				});

				$('#fitbuildercruisedayimage-search').prop('disabled', true);
				$('.reset-place').removeClass('hidden');
			},
			function template(item) {
				var html;

				html = item.name;
				return html;
			}
		);

		$('.pictures').on('click', '.google-image', function _selectPicture() {
			var src  = $(this).data('src'),
				$obj = $(this);
			
			$('.google-image').removeClass('google-image-active');

			$obj.addClass('google-image-active');

			$('#image_url').val(src);
		});

		$('#reset-place-link').click(function _clearPlace(e) {
			e.preventDefault();

			$('#fitbuildercruisedayimage-search').val('');
			$('#fitbuildercruisedayimage-search').prop('disabled', false);
			$('#image_url').val('');
			$('.reset-place').addClass('hidden');
			$('.pictures').html('');
		});
	};
}(jQuery, window.Adzuki || {}));